import EditSitePage from './EditSite';
import { createEditSiteHandle } from './handle';

export default {
  Component: EditSitePage,
  createHandle: createEditSiteHandle
};
